module.exports = __webpack_public_path__ + "static/5dd9f4c4-cfde-415c-bb51-433569311de5-d5558fcdf128ed11046a818a692bae0f.woff2";